import {useGetRequestData} from './client';

export const useCommunityReportReasons = (feedbackCh, community, time) =>
    useGetRequestData(feedbackCh, community && `/api/v2/community/report_reasons?community=${community}&time=${time}`);
